import { render, staticRenderFns } from "./AddMuestraModal.vue?vue&type=template&id=6a9fd4af&"
import script from "./AddMuestraModal.vue?vue&type=script&lang=ts&"
export * from "./AddMuestraModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports